import React, { Children, cloneElement } from "react";
// import Icon from '../icon/Icon';

const ToastHeader = ({ icon, iconColor, title, time, isDismiss, ...props }) => {
  const { onDismiss } = props; // extracted from props
  return (
    <div className="toast-header">
      {/* {icon && <Icon icon={icon} size='lg' color={iconColor} className='me-2' />} */}
      {title && <strong className="me-auto">{title}</strong>}
      {time && <small>{time}</small>}
      {isDismiss && onDismiss}
    </div>
  );
};

const ToastBody = ({ children }) => {
  return <div className="toast-body">{children}</div>;
};

export const Toast = ({ children, onDismiss }) => {
  return (
    <div
      className="toast show"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      {Children.map(children, (child, index) =>
        cloneElement(child, {
          key: index,
          onDismiss: (
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onDismiss}
            />
          ),
        })
      )}
    </div>
  );
};

export const ToastContainer = ({ children }) => {
  return (
    <div className="toast-container position-fixed top-0 end-0 p-3">
      {children}
    </div>
  );
};

// eslint-disable-next-line react/prop-types
export const ToastCloseButton = ({ closeToast }) => (
  <button type="button" className="btn-close" aria-label="Close" />
);

const Toasts = ({ icon, iconColor, title, time, children }) => {
  return (
    <>
      <ToastHeader
        icon={icon}
        iconColor={iconColor}
        title={title}
        time={time}
      />
      <ToastBody>{children}</ToastBody>
    </>
  );
};

export default Toasts;
